import React, { useCallback, useContext, useMemo, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HistoryStackContext } from '../HistoryStackContext';
import { v4 as uuidv4 } from 'uuid';

import "./Popup.scss"

export default function Popup({ popupId, baseZIndex, name, children, inBottom }) {
    const hs = useContext(HistoryStackContext);
    const path = "/popup/" + String(popupId);

    const pageInStack = useMemo(() => {
        return hs.findPageInStack({ path });
    }, [hs, path]);

    const show = pageInStack !== undefined;
    const dismiss = useCallback(() => {
        hs.checkAndBack({ path })
    }, [hs, path]);

    return <LegacyPopup
        show={show} dismiss={dismiss} baseZIndex={baseZIndex}
        name={name} children={children} inBottom={inBottom} />;
}

export function usePopup() {
    const hs = useContext(HistoryStackContext);

    const popupId = useState(uuidv4())[0];
    const path = "/popup/" + String(popupId);

    const showPopup = useCallback(() => {
        hs.push(path, undefined, false);
    }, [hs, path]);

    const dismissPopup = useCallback(() => {
        hs.checkAndBack({ path });
    }, [hs, path]);

    return [popupId, showPopup, dismissPopup];
}

// also used for undismissable popups
export function LegacyPopup({ show, dismiss, baseZIndex, name, children, inBottom }) {
    let variants = {
        initial: {
            opacity: 0,
            transform: "translate(-50%, -65%)"
        },
        animate: {
            opacity: 1,
            transform: "translate(-50%, -50%)"
        },
        exit: {
            opacity: 0,
            transform: "translate(-50%, -65%)"
        }
    };
    if (inBottom) {
        variants = {
            initial: {
                transform: "translateY(100%)"
            },
            animate: {
                transform: "translateY(0%)"
            },
            exit: {
                transform: "translateY(100%)"
            }
        };
    }

    return (
        <AnimatePresence>
            {show && (<motion.div
                initial="initial"
                animate="animate"
                exit="exit"
                variants={{
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    }
                }}
                transition={{
                    ease: "easeInOut",
                    duration: 0.5,
                }}
                className="general-popup-back"
                style={{
                    zIndex: baseZIndex
                }}
                key={name + "_back"}
                onClick={dismiss ? dismiss : () => { }}
            />)}
            {show && (<motion.div
                initial="initial"
                animate="animate"
                exit="exit"
                variants={variants}
                transition={{
                    ease: "easeInOut",
                    duration: 0.5,
                }}
                className={inBottom ? "general-popup-front bottom" : "general-popup-front"}
                key={name + "_front"}
                style={{
                    zIndex: baseZIndex
                }}
            >
                {children}
            </motion.div>)}
        </AnimatePresence>
    )
}